'use strict';

import siteFooterTemplate from './footer.html';

export const siteFooterDirName = 'siteFooter';
export function siteFooterDir() {
  return {
    restrict: 'E',
    template: siteFooterTemplate
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/footer/footer.js